import * as actions from './redux/actions';
import * as homeActions from '../../home/redux/actions';

import {
  KuposErrorSuccessModal,
  KuposModalWithButtons,
  KuposSuccessFailure,
  NewSearchBox,
  ServiceFilter,
} from '../../common';
import React, { Component } from 'react';

import ApiUrls from '../../../services/apiUrls';
import CommonService from '../../../services/commonService';
import DateService from '../../../services/dateService';
import { Helmet } from 'react-helmet';
import KuposCapsuleMenu from '../../common/KuposCapsuleMenu';
import KuposSteps from '../../common/KuposSteps';
import PropTypes from 'prop-types';
import SelectedServiceMore from './SelectedServiceMore/SelectedServiceMore';
import ServiceItem from './ServiceItem/ServiceItem';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import i18next from 'i18next';
import { withTranslation } from 'react-i18next';
import axios from 'axios';

// import * as homeActions from '../home/redux/actions';

// import ServiceFilter from './ServiceFilter';

const cities = [
  { value: '1', label: 'Santiago' },
  { value: '2', label: 'Puerto mont' },
  { value: '3', label: 'Vina del mar' },
];

const filtersArray = [
  {
    title: 'DEPTARTURE_TIME',
    type: 'time',
    align: 'left',
    options: [
      { icon: 'sunrise', value: 'sunrise', label: 'Antes de las 6AM', trText: 'SUNRISE' },
      { icon: 'morning', value: 'morning', label: '6AM a 12AM', trText: 'MORNING' },
      { icon: 'sunset', value: 'sunset', label: '12AM a 18PM', trText: 'SUNSET' },
      { icon: 'night', value: 'night', label: 'Despues de las 18PM', trText: 'NIGHT' },
    ],
  },
];
let seatsSelected = 0;

export class DefaultPage extends Component {
  static propTypes = {
    pbServiceList: PropTypes.object.isRequired,
    home: PropTypes.object.isRequired,
    common: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };

  capsuleMenuIcons = [
    {
      icon: '/images/icons/service-sort/icon-clock-line.png',
      iconActive: '/images/icons/service-sort/icon-clock-line-pink.png',
      label: 'SCHEDULES_DAY_NIGHT',
      sortFeild: 'dep_time',
    },
    // {
    //   icon: '/images/icons/service-sort/icon-bus-line.png',
    //   iconActive: '/images/icons/service-sort/icon-bus-line-pink.png',
    //   label: 'COMAPNIES_ATOZ',
    //   sortFeild: 'operator_service_name',
    // },
    {
      icon: '/images/icons/service-sort/icon-piggybank-line.png',
      iconActive: '/images/icons/service-sort/icon-piggybank-line-pink.png',
      label: 'BEST_PRICE',
      sortFeild: 'fare_str',
    },
    // {
    //   icon: '/images/icons/service-sort/icon-star-line.png',
    //   iconActive: '/images/icons/service-sort/icon-star-line-pink.png',
    //   label: 'BEST_RANKING',
    //   sortFeild: 'rating',
    // },
    {
      icon: '/images/icons/service-sort/icon-chronometer-line.png',
      iconActive: '/images/icons/service-sort/icon-chronometer-line-pink.png',
      label: 'FASTER',
      sortFeild: 'duration',
    },
  ];
  filtersAdded = false;

  constructor(props) {
    super(props);
    this.source = axios.CancelToken.source();
    this.serviceLoaded = false;
    // console.log(this.props);
    // let fromPaymentGateway = localStorage.getItem('paymentGatewayOpened');
    // if (fromPaymentGateway) {
    //   this.props.history.replace(``, null);
    //   this.props.history.push(`/booking/failure`);
    // }
    localStorage.removeItem('paymentGatewayOpened');
    this.originCityDecoded = this.props.match.params.originOnward
      .split('--')
      .join('+')
      .split('-')
      .join(' ')
      .split('+')
      .join('-')
      .toLowerCase();
    this.destCityDecoded = this.props.match.params.destOnward
      .split('--')
      .join('+')
      .split('-')
      .join(' ')
      .split('+')
      .join('-')
      .toLowerCase();
    this.state = {
      getServiceListPending: true,
      showNoReturnPopup: true,
      serviceList: null,
      openNewSearch: false,
      stepsMenu: [
        { label: 'GOING', active: true },
        { label: 'RETURN' },
        { label: 'PAYMENT' },
        { label: 'CONFIRMATION' },
      ],
      activeSortTab: 2,
      originIdOnward: null,
      destIdOnward: null,
      journeyDateOnward: null,
      selectedService: null,
      orderBy: 'ASC',
      // floor: this.props.pbServiceList.selectedServiceOnward.upperAvalibility ? 'upper' : 'lower',
      floor: 0,
      filtersArray: [
        {
          title: 'DEPTARTURE_TIME',
          type: 'time',
          align: 'left',
          options: [
            { icon: 'sunrise', value: 'sunrise', label: 'Antes de las 6AM', trText: 'SUNRISE' },
            { icon: 'morning', value: 'morning', label: '6AM a 12AM', trText: 'MORNING' },
            { icon: 'sunset', value: 'sunset', label: '12AM a 18PM', trText: 'SUNSET' },
            { icon: 'night', value: 'night', label: 'Despues de las 18PM', trText: 'NIGHT' },
          ],
        },
      ],
    };
    this.operatorId = CommonService.getParameterByName('operator_id');
    console.log('All props are----', this.props);

    sessionStorage.removeItem('isTSService');
    sessionStorage.removeItem('isTSServiceRound');
    sessionStorage.removeItem('preBlockResponseDataOnward');
    sessionStorage.removeItem('preBlockResponseDataReturn');
    // sessionStorage.clear();

    this.addProductImpression();
  }

  addProductImpression = () => {
    if (!this.props.home.pbSourceCity) {
      return;
    }
    let impData = [];

    let data = {
      // id: 1, // Optional
      name: `${CommonService.isTrain() ? 'train' : 'bus'}-${
        this.props.home.pbSourceCity.label
      } to ${this.props.home.pbDestinationCity.label}`, // Compulsory
      price: 1,
      brand: 'pullmanbus.cl',
      category: CommonService.isTrain() ? 'train' : 'bus',
      variant: `${DateService.getCurrentTime()}`,
      position: 1,
      list: `${this.props.home.pbSourceCity.label}-${this.props.home.pbDestinationCity.label}`,
    };

    impData.push(data);

    CommonService.pushProductImpression('productImpression', impData);
  };

  // componentWillMount() {
  //   console.log('componentWillMount called ---------');
  // }

  componentDidMount() {
    // console.log('PB service componentDidMount-------', this.props.pbServiceList);
    // console.log("CommonService.getLocal('pbServiceList')", CommonService.getLocal('pbServiceList'));

    seatsSelected = 0;
    try {
      localStorage.removeItem('paymentGatewayOpened');
      this._isMounted = true;
      window.onpopstate = e => {
        //your code...
        if (this._isMounted) {
          this.componentDidMount();
        }
      };
      CommonService.newSearchFunction = this.newSearch.bind(this);
      window.scrollTo(0, 0);
      const {
        pageType,
        originOnward,
        destOnward,
        tripStep,
        journeyDateOnward,
        journeyDateReturn,
      } = this.props.match.params;
      this.pageType = pageType;
      this.tripStep = tripStep;
      this.originOnward = decodeURI(originOnward);
      this.destOnward = decodeURI(destOnward);
      this.journeyDateOnward = journeyDateOnward;
      //return
      this.journeyDateReturn = journeyDateReturn;
      let pbServiceList = CommonService.getLocal('pbServiceList');
      if (pbServiceList) {
        let home = CommonService.getLocal('home');
        CommonService.removeLocal('pbServiceList');
        if (home) {
          this.loadServices(
            home.pbSourceCity.value,
            home.pbDestinationCity.value,
            DateService.changeDateFormat(home.onwardPBDate, 'dd-mm-yyyy', 'yyyy-mm-dd'),
            2,
          );
        }
      } else if (
        ((CommonService.isTrain() && this.props.home.uniqueCitiesTrain) ||
          (!CommonService.isTrain() && this.props.home.uniqueCities)) &&
        this.pageType != 'passenger-details' &&
        !this.props.pbServiceList.serviceList &&
        originOnward &&
        destOnward
      ) {
        let checkOriginCity = originOnward
          .split('--')
          .join('+')
          .split('-')
          .join(' ')
          .split('+')
          .join('-')
          .toLowerCase();
        let checkDestCity = destOnward
          .split('--')
          .join('+')
          .split('-')
          .join(' ')
          .split('+')
          .join('-')
          .toLowerCase();

        let filterCities = (CommonService.isTrain()
          ? this.props.home.uniqueCitiesTrain
          : this.props.home.uniqueCities
        ).filter(it => {
          return (
            it.label.toLowerCase() == checkOriginCity || it.label.toLowerCase() == checkDestCity
          );
        });
        if (filterCities) {
          let originCity = filterCities.find(it => {
            return it.label.toLowerCase() == checkOriginCity;
          });
          let destCity = filterCities.find(it => {
            return it.label.toLowerCase() == checkDestCity;
          });
          if (originCity && destCity) {
            this.sourceCityOnChange(originCity);
            this.destinationCityOnChange(destCity);
            this.originIdOnward = originCity.value;
            this.destIdOnward = destCity.value;
          }
        }
      } else if (this.props.home.pbSourceCity && this.props.home.pbDestinationCity) {
        this.originIdOnward = this.props.home.pbSourceCity.value;
        this.destIdOnward = this.props.home.pbDestinationCity.value;
      }
      this.onLoadSetup();
    } catch (e) {
      console.log(e);
    }
  }

  onLoadSetup = () => {
    try {
      this.onwardDateChange(this.journeyDateOnward);
      if (!this.journeyDateReturn) this.setupStepMenu(1, 1);
      else this.setupStepMenu(1, 2);
      if (this.journeyDateReturn) this.returnDateChange(this.journeyDateReturn);

      this.loadServices(
        this.originIdOnward,
        this.destIdOnward,
        DateService.changeDateFormat(this.journeyDateOnward, 'dd-mm-yyyy', 'yyyy-mm-dd'),
        this.tripStep,
      );
    } catch (e) {
      console.log(e);
    }
  };

  componentDidUpdate() {
    try {
      const {
        pageType,
        originOnward,
        destOnward,
        tripStep,
        journeyDateOnward,
        journeyDateReturn,
      } = this.props.match.params;
      this.pageType = pageType;
      this.tripStep = tripStep;
      this.originOnward = originOnward;
      this.destOnward = destOnward;
      if (this.tripStep == 1) {
        if (this.stapMenuActive != 1) {
          this.setupStepMenu(1, 2);
        }
      } else if (this.tripStep == 2) {
        if (this.stapMenuActive != 2) {
          this.setupStepMenu(2, 2);
        }
      } else {
        if (this.stapMenuActive != 1) {
          this.setupStepMenu(1, 1);
        }
      }
      if (this.routesRes && !this.filtersAdded && this.props.home.metaData) {
        this.filtersAdded = true;
        this.createFilters(this.routesRes);
      }
      if (
        ((CommonService.isTrain() && this.props.home.uniqueCitiesTrain) ||
          (!CommonService.isTrain() && this.props.home.uniqueCities)) &&
        this.pageType != 'passenger-details' &&
        !this.props.pbServiceList.serviceList
      ) {
        if (this.tripStep == 2) {
          this.props.history.push(
            `/${i18next.language}/${
              CommonService.isTrain()
                ? i18next.language == 'es'
                  ? 'pasajes-tren'
                  : 'train-tickets'
                : i18next.language == 'es'
                ? 'pasajes-bus'
                : 'bus-tickets'
            }/${originOnward}/${destOnward}/${journeyDateOnward}/${journeyDateReturn}/1`,
          );
        } else {
          let checkOriginCity = originOnward
            .split('--')
            .join('+')
            .split('-')
            .join(' ')
            .split('+')
            .join('-')
            .toLowerCase();
          let checkDestCity = destOnward
            .split('--')
            .join('+')
            .split('-')
            .join(' ')
            .split('+')
            .join('-')
            .toLowerCase();
          let filterCities = (CommonService.isTrain()
            ? this.props.home.uniqueCitiesTrain
            : this.props.home.uniqueCities
          ).filter(it => {
            return (
              it.label.toLowerCase() == checkOriginCity || it.label.toLowerCase() == checkDestCity
            );
          });
          if (filterCities && !this.props.home.pbDestinationCity && !this.props.home.pbSourceCity) {
            let originCity = filterCities.find(it => {
              return it.label.toLowerCase() == checkOriginCity;
            });
            let destCity = filterCities.find(it => {
              return it.label.toLowerCase() == checkDestCity;
            });
            let navBar = document.querySelector('.nav-section');
            if (originCity && destCity) {
              this.sourceCityOnChange(originCity);
              this.destinationCityOnChange(destCity);
              this.originIdOnward = originCity.value;
              this.destIdOnward = destCity.value;
              this.onLoadSetup();
              CommonService.removeClass(navBar, 'payments-page-header');
            } else {
              let newHeaderSearch = document.querySelector('.nav-section .common-new-search-box');
              if (!this.serviceList) {
                this.serviceList = 'NO_ROUTES_FOUND';
                this.setState({
                  serviceList: 'NO_ROUTES_FOUND',
                });
                newHeaderSearch.style.display = 'none';
                CommonService.add(navBar, 'payments-page-header');
              }
            }
          } else {
          }
        }
      }
    } catch (e) {
      console.log(e);
    }
  }

  setupStepMenu = (step, type) => {
    try {
      let stepsMenu;
      this.stapMenuActive = step;
      if (type == 1) {
        stepsMenu = [
          { label: 'GOING', active: step == 1 },
          { label: 'PAYMENT', active: step == 2 },
          { label: 'CONFIRMATION', active: step == 3 },
        ];
      } else {
        stepsMenu = [
          { label: 'GOING', active: step == 1 },
          { label: 'RETURN', active: step == 2 },
          { label: 'PAYMENT', active: step == 3 },
          { label: 'CONFIRMATION', active: step == 4 },
        ];
      }
      this.setState({ stepsMenu: stepsMenu });
    } catch (e) {
      console.log(e);
    }
  };

  loadServices = (originId, destId, journeyDate, step = 1, retryCount = 0) => {
    if (!step || step == 1) {
    }
    if (step == 2) {
      if (sessionStorage.getItem('preBlockResponseDataReturn')) {
        let preBlockResponseDataReturn = JSON.parse(
          sessionStorage.getItem('preBlockResponseDataReturn'),
        );
      }
      sessionStorage.removeItem('preBlockResponseDataReturn');
    }
    if (originId && destId && journeyDate)
      this.props.actions
        .getServiceList({
          url: ApiUrls.serviceListV2(
            originId,
            destId,
            journeyDate,
            this.journeyDateReturn
              ? DateService.changeDateFormat(this.journeyDateReturn, 'dd-mm-yyyy', 'yyyy-mm-dd')
              : null,
            retryCount,
            this.props.home.is_mot,
          ),
          v2: true,
        })
        .then(res => {
          console.log('Response from search is------', res);
          try {
            const selectedServiceOnward = CommonService.copyObject(
              this.props.pbServiceList.selectedServiceOnward,
            );
            const selectedServiceReturn = CommonService.copyObject(
              this.props.pbServiceList.selectedServiceReturn,
            );
            this.serviceListResponseFull = res;
            let maxRetryCount = 0;

            if (step == 1) {
              this.retryFlag = res.retryFlag;
              this.waitTime = res.waitTime;
              if (!this.serviceLoaded) {
                this.maxRetryCount = res.maxRetryCount;
                this.serviceLoaded = true;
              }
              if (
                Array.isArray(res.body && res.body.onward_schedules) &&
                res.body.onward_schedules.length
              ) {
                this.maxRetryCount = 0;
                this.setState({ all_service_schedules: res.body });
              }
              maxRetryCount = this.maxRetryCount || 0;
              if (this.retryFlag && this.maxRetryCount > 0) {
                this.maxRetryCount--;
                retryCount++;
                setTimeout(() => {
                  this.loadServices(originId, destId, journeyDate, step, retryCount);
                }, this.waitTime * 1000);
              } else if (
                res &&
                res.code === 400 &&
                res.message.includes('Servicios no encontrados')
              ) {
                this.setState({
                  getServiceListPending: false,
                });
                // this.setServices(null)
                // CommonService.fullServiceListV2 = null
              } else {
                this.setState({
                  getServiceListPending: false,
                });
                this.props.actions.setServiceListOnward(res.body.onward_schedules);
                this.props.actions.setServiceOnward({
                  coachLayoutJson: null,
                  originStageDetails: null,
                  destinationStageDetails: null,
                  boardingStage: null,
                  droppingStage: null,
                  route: null,
                  selectedService: null,
                });
              }
              // console.log('Service List before set', res);
            } else {
              this.retryFlag = res.retryFlag;
              this.waitTime = res.waitTime;
              if (!this.serviceLoaded) {
                this.maxRetryCount = res.maxRetryCount;
                this.serviceLoaded = true;
              }
              if (Array.isArray(res.body.return_schedules) && res.body.return_schedules.length) {
                this.maxRetryCount = 0;
              }
              maxRetryCount = this.maxRetryCount || 0;
              if (this.retryFlag && this.maxRetryCount > 0) {
                this.maxRetryCount--;
                retryCount++;
                setTimeout(() => {
                  this.loadServices(originId, destId, journeyDate, step, retryCount);
                }, this.waitTime * 1000);
              } else {
                this.props.actions.setServiceListReturn(res);
                this.props.actions.setServiceReturn({
                  coachLayoutJson: null,
                  originStageDetails: null,
                  destinationStageDetails: null,
                  boardingStage: null,
                  droppingStage: null,
                  route: null,
                  selectedService: null,
                });
                this.setState({
                  getServiceListPending: false,
                });
              }
            }
            if (!this.retryFlag || !maxRetryCount > 0) {
              setTimeout(() => {
                if (
                  step == 1 &&
                  selectedServiceOnward.route &&
                  this.props.pbServiceList.selectedService
                ) {
                  let isBlock = false;
                  this.props.actions.selectSeatOnward({
                    totalBookingAmount: 0,
                    netBookingAmount: 0,
                    discountAmount: 0,
                    selectedSeatsToBook: null,
                    selectedSeatsNumbers: null,
                    selectedSeatTypes: null,
                  });
                  if (sessionStorage.getItem('preBlockResponseDataOnward')) {
                    let preBlockResponseDataOnward = JSON.parse(
                      sessionStorage.getItem('preBlockResponseDataOnward'),
                    );
                    if (preBlockResponseDataOnward && preBlockResponseDataOnward.releaseData) {
                      isBlock = true;
                      this.releaseSeats(
                        this.props.pbServiceList.selectedService,
                        preBlockResponseDataOnward.releaseData,
                      );
                    }
                  }

                  if (!isBlock)
                    this.onBookButtonPress(this.props.pbServiceList.selectedService, step);
                } else if (
                  step == 2 &&
                  selectedServiceReturn.route &&
                  this.props.pbServiceList.selectedService
                ) {
                  let isBlock = false;
                  this.props.actions.selectSeatReturn({
                    totalBookingAmount: 0,
                    netBookingAmount: 0,
                    discountAmount: 0,
                    selectedSeatsToBook: null,
                    selectedSeatsNumbers: null,
                    selectedSeatTypes: null,
                  });
                  if (sessionStorage.getItem('preBlockResponseDataReturn')) {
                    let preBlockResponseDataReturn = JSON.parse(
                      sessionStorage.getItem('preBlockResponseDataReturn'),
                    );
                    if (preBlockResponseDataReturn && preBlockResponseDataReturn.releaseData) {
                      isBlock = true;
                      this.releaseSeats(
                        this.props.pbServiceList.selectedService,
                        preBlockResponseDataReturn.releaseData,
                      );
                    }
                  }
                  if (!isBlock)
                    this.onBookButtonPress(this.props.pbServiceList.selectedService, step);
                }
              }, 500);
              let navBar = document.querySelector('.nav-section');
              let newHeaderSearch = document.querySelector('.nav-section .common-new-search-box');
              if (res.body && res.body.onward_schedules) {
                this.routesRes =
                  this.tripStep == 2 ? res.body.return_schedules : res.body.onward_schedules;
                if (this.props.home.metaData) this.filtersAdded = true;
                this.createFilters(this.routesRes);
                if (newHeaderSearch) newHeaderSearch.style.display = 'block';
                CommonService.removeClass(navBar, 'payments-page-header');
              } else {
                this.setState({
                  serviceList: 'NO_ROUTES_FOUND',
                });
                CommonService.add(navBar, 'payments-page-header');
                if (newHeaderSearch) newHeaderSearch.style.display = 'none';
              }
            }
          } catch (e) {
            console.log(e);
          }
        });
  };

  createFilters = res => {
    let filterState = CommonService.copyObject(filtersArray);
    let filters = CommonService.getServiceFilters(
      (res || []).filter(it => it.travel_id == this.operatorId || !this.operatorId),
      this.props.home.metaData,
    );

    // console.log('filters-------', filters)

    if (filters) {
      filterState.push(filters.operators);
      filterState.push(filters.amenities);
      filterState.push(filters.seatTypes);
      this.setState({
        filtersArray: filterState,
        serviceList: res || [],
        activeSortTab: 0,
        orderBy: 'ASC',
        orderByField: null,
      });
      setTimeout(() => {
        this.sortBy(0, res || []);
      }, 100);
    }
  };

  onStepClick = menu => {
    if (this.tripStep == 2 && menu == 1) {
      window.history.go(-1);
    }
  };

  clearSelectedSeats = (type = 1) => {
    // console.log('Seats closed status', type);
    seatsSelected = 0;
    this.setState({ seatsCleared: true });
    let data = {
      totalBookingAmount: 0,
      netBookingAmount: 0,
      discountAmount: 0,
      selectedSeatsToBook: null,
      selectedSeatsNumbers: null,
      selectedSeatTypes: null,
    };
    if (type == 1) {
      // this.onSeatSelectOnward(data, true);
      this.props.actions.selectSeatOnward(data);
    } else {
      this.props.actions.selectSeatReturn(data);
      // this.onSeatSelectReturn(data, true);
    }
  };

  seatSelectedSeatsOnward = () => {
    try {
      let seats = this.selectedSeatsOnward.split(',');
      for (let seat of seats) {
        let seatObject;
        if (this.props.pbServiceList.selectedServiceOnward.coachLayoutJson)
          for (let row of this.props.pbServiceList.selectedServiceOnward.coachLayoutJson) {
            seatObject = row.find(it => it.number == seat);
            if (seatObject) {
              let bookingDetails = CommonService.selectSeat(
                seatObject,
                this.props.home.metaData,
                this.props.pbServiceList.selectedServiceOnward.coachLayoutJson,
                this.props.pbServiceList.bookingDetailsOnward.selectedSeatsToBook,
              );
              this.onSeatSelectOnward(bookingDetails);
              break;
            }
          }
      }
    } catch (e) {
      console.log(e);
    }
  };
  seatSelectedSeatsReturn = () => {
    try {
      let seats = this.selectedSeatsReturn.split(',');
      for (let seat of seats) {
        let seatObject;
        if (this.props.pbServiceList.selectedServiceReturn.coachLayoutJson)
          for (let row of this.props.pbServiceList.selectedServiceReturn.coachLayoutJson) {
            seatObject = row.find(it => it.number == seat);
            if (seatObject) {
              let bookingDetails = CommonService.selectSeat(
                seatObject,
                this.props.home.metaData,
                this.props.pbServiceList.selectedServiceReturn.coachLayoutJson,
                this.props.pbServiceList.bookingDetailsReturn.selectedSeatsToBook,
              );
              this.onSeatSelectReturn(bookingDetails);
              break;
            }
          }
      }
    } catch (e) {
      console.log(e);
    }
  };

  onwardDateChange = date => {
    this.props.actions.setOnwardPbDate(date);
  };

  returnDateChange = date => {
    this.props.actions.setReturnPbDate(date);
  };

  sourceCityOnChange = value => {
    // console.log('Value of origin', value);
    this.props.actions.pbSetSourceCity(value);
  };
  destinationCityOnChange = value => {
    // console.log('Value of dest', value);
    this.props.actions.pbSetDestinationCity(value);
  };

  onBoardingPointChange = value => {
    try {
      if (this.tripStep != 2) {
        this.setState({ boardingErrorMessage: null });
        let stage =
          this.props.pbServiceList.selectedServiceOnward.originStageDetails &&
          this.props.pbServiceList.selectedServiceOnward.originStageDetails.find(
            it => it.id == value.value,
          );
        let serviceDetails = this.props.pbServiceList.selectedServiceOnward;
        serviceDetails.boardingStage = stage;
        this.props.actions.setServiceOnward(serviceDetails);
      } else {
        this.setState({ boardingErrorMessage: null });
        let stage =
          this.props.pbServiceList.selectedServiceReturn.originStageDetails &&
          this.props.pbServiceList.selectedServiceReturn.originStageDetails.find(
            it => it.id == value.value,
          );
        let serviceDetails = this.props.pbServiceList.selectedServiceReturn;
        serviceDetails.boardingStage = stage;
        this.props.actions.setServiceReturn(serviceDetails);
      }
    } catch (e) {
      console.log(e);
    }
  };

  onDroppingPointChange = value => {
    try {
      if (this.tripStep != 2) {
        this.setState({ droppingErrorMessage: null });
        let stage =
          this.props.pbServiceList.selectedServiceOnward.destinationStageDetails &&
          this.props.pbServiceList.selectedServiceOnward.destinationStageDetails.find(
            it => it.id == value.value,
          );
        let serviceDetails = this.props.pbServiceList.selectedServiceOnward;
        serviceDetails.droppingStage = stage;
        this.props.actions.setServiceOnward(serviceDetails);
      } else {
        this.setState({ droppingErrorMessage: null });
        let stage =
          this.props.pbServiceList.selectedServiceReturn.destinationStageDetails &&
          this.props.pbServiceList.selectedServiceReturn.destinationStageDetails.find(
            it => it.id == value.value,
          );
        let serviceDetails = this.props.pbServiceList.selectedServiceReturn;
        serviceDetails.droppingStage = stage;
        this.props.actions.setServiceReturn(serviceDetails);
      }
    } catch (e) {
      console.log(e);
    }
  };

  sortBy = (i, arr) => {
    try {
      let orderBy = i === 1 || i === 2 || i === 3 ? 'DESC' : 'ASC';
      let sortFeild = this.capsuleMenuIcons[i].sortFeild;
      if (this.dateChanged) {
        orderBy = this.state.orderBy;
      }
      if (this.state.orderByField == sortFeild) {
        if (this.state.orderBy === 'ASC') {
          orderBy = 'DESC';
        } else if (this.state.orderBy === 'DESC' && (i === 1 || i === 2 || i === 3)) {
          orderBy = 'ASC';
        }
      }
      let routes;
      if (!arr)
        if (this.tripStep == 2) {
          routes = CommonService.copyObject(this.state.serviceList);
        } else {
          routes = CommonService.copyObject(this.state.serviceList);
        }
      else routes = CommonService.copyObject(arr);

      let routesFull = this.sortThis(routes, sortFeild, orderBy);
      // let routes = routesFull.filter(it => {
      //   return it.available_seats > 0;
      // })
      // let soldRoutes = routesFull.filter(it => {
      //   return it.available_seats <= 0;
      // })
      // for(let route of soldRoutes){
      //   route.soldRoute = true
      // }
      routes = routesFull;
      this.setState({
        orderByField: sortFeild,
        orderBy: orderBy,
        activeSortTab: i,
        serviceList: routes,
      });
    } catch (e) {
      console.log(e);
    }
  };

  /**
   * ascending descending method
   */
  isAsc = () => {
    if (this.state.orderBy === 'ASC') {
      return true;
    } else {
      return false;
    }
  };

  /**
   * sort method
   */
  sortThis = (arr, orderByValue, orderType = 'ASC') => {
    try {
      arr.sort((a, b) => {
        if (orderType === 'ASC') {
          if (orderByValue == 'operator_service_name') {
            if (a[orderByValue] < b[orderByValue]) return 1;
            if (a[orderByValue] > b[orderByValue]) return -1;
            return 0;
          } else if (orderByValue == 'dep_time') {
            // return (Date.parse('1970/01/01 ' + a[orderByValue]) - Date.parse('1970/01/01 ' + b[orderByValue]))
            if (a[orderByValue] < b[orderByValue]) return -1;
            if (a[orderByValue] > b[orderByValue]) return 1;
            return 0;
          } else if (orderByValue == 'rating') {
            if (a.operator_details[1] < b.operator_details[1]) return -1;
            if (a.operator_details[1] > b.operator_details[1]) return 1;
            return 0;
          } else if (orderByValue == 'duration') {
            if (a[orderByValue] < b[orderByValue]) return -1;
            if (a[orderByValue] > b[orderByValue]) return 1;
            return 0;
          } else {
            if (a[orderByValue] && b[orderByValue]) {
              let aValue = a[orderByValue].split(':');
              let bValue = b[orderByValue].split(':');
              if (Number.parseInt(aValue[1]) < Number.parseInt(bValue[1])) return 1;
              if (Number.parseInt(aValue[1]) > Number.parseInt(bValue[1])) return -1;
            }
            return 0;
          }
        } else {
          if (orderByValue == 'operator_service_name') {
            if (a[orderByValue] < b[orderByValue]) return -1;
            if (a[orderByValue] > b[orderByValue]) return 1;
            return 0;
          } else if (orderByValue == 'dep_time') {
            // return -(Date.parse('1970/01/01 ' + a[orderByValue]) - Date.parse('1970/01/01 ' + b[orderByValue]))
            if (a[orderByValue] < b[orderByValue]) return 1;
            if (a[orderByValue] > b[orderByValue]) return -1;
            return 0;
          } else if (orderByValue == 'rating') {
            if (a.operator_details[1] < b.operator_details[1]) return 1;
            if (a.operator_details[1] > b.operator_details[1]) return -1;
            return 0;
          } else if (orderByValue == 'duration') {
            if (a[orderByValue] < b[orderByValue]) return 1;
            if (a[orderByValue] > b[orderByValue]) return -1;
            return 0;
          } else {
            if (a[orderByValue] && b[orderByValue]) {
              let aValue = a[orderByValue].split(':');
              let bValue = b[orderByValue].split(':');
              if (Number.parseInt(aValue[1]) > Number.parseInt(bValue[1])) return 1;
              if (Number.parseInt(aValue[1]) < Number.parseInt(bValue[1])) return -1;
            }
            return 0;
          }
        }
      });
    } catch (e) {
      console.log(e);
    }
    return arr;
  };

  // onServiceSelect = (service) => {
  //   if (service.available_seats <= 0) {
  //     return false;
  //   }
  //   this.getServiceDetails(service.id,service);
  // }

  checkMidnight = (service, step) => {
    if (service.dep_validation_text) {
      this.setState({
        showModal: true,
        modalTitle: '',
        modalBody: service.dep_validation_text,
        showButton1: true,
        buttonText1: this.props.t('RESULTS_PAGE.CHOOSE_ANOTHER_TRIP'),
        onButtonClick1: this.closeModal,
        showButton2: true,
        buttonText2: this.props.t('RESULTS_PAGE.CONTINUE'),
        onButtonClick2: () => {
          this.closeModal();
          this.onBookButtonPress(service, step);
        },
      });
      return;
    } else {
      this.onBookButtonPress(service, step);
    }
  };

  onBookButtonPress = (service, step) => {
    if (service.available_seats <= 0) {
      return false;
    }

    CommonService.googleProductClick({
      // id: service.id, // Optional
      name: `${CommonService.isTrain() ? 'train' : 'bus'}-${
        this.props.home.pbSourceCity.label
      } to ${this.props.home.pbDestinationCity.label}`, // Compulsory
      price: service.fare_str && Number(service.fare_str.split(',')[0].split(':')[1]),
      brand: service.operator_service_name,
      category: CommonService.isTrain() ? 'train' : 'bus',
      variant: service.dep_time,
      position: 1,
      list: `${this.props.home.pbSourceCity.label}-${this.props.home.pbDestinationCity.label}`,
    });

    this.clearSelectedSeats(step);
    this.props.actions.setSelectedService(null);
    this.setState({
      selectedService: service,
      floor: 0,
    });

    this.source.cancel();

    this.source = axios.CancelToken.source();
    setTimeout(() => {
      this.getServiceDetails(service.id, service, step, this.source.token);
    }, 200);
    // this.props.actions.setSelectedService(CommonService.setSeatLayout(CommonService.makeServiceDetailsApi(layout),route));
  };

  getServiceDetails = (scheduleId, route, step, cancelToken) => {
    // store

    console.log('testing getServiceDetails-------', route);

    this.setState({
      selectedServiceError: null,
      petSeats: null,
    });
    this.props.actions
      .getSelectedService({
        url: ApiUrls.serviceDetailsV2(scheduleId, this.props.home.is_mot),
        cancelToken,
      })
      .then(selectedService => {
        if (selectedService && !selectedService.error) {
          console.log('testing Selected Service details', selectedService);
          if (
            selectedService &&
            selectedService.res_details &&
            selectedService.res_details.pet_seat_info
          ) {
            this.setState({ petSeats: selectedService.res_details.pet_seat_info });
          }
          this.onServiceDetailsResponse(selectedService, scheduleId, route, step);
          this.props.actions.setSelectedService(selectedService);
        } else {
          this.setState({
            selectedServiceError:
              (selectedService && selectedService.error.message) ||
              this.props.t('RESULTS_PAGE.SOLD_OUT_MSG'),
          });
        }
      });
  };

  onServiceDetailsResponse = (selectedService, scheduleId, route, step) => {
    if (selectedService) {
      this.checkSeatAvailability(selectedService, scheduleId, route, step);
    }
  };

  checkSeatAvailability = (serviceDetails, scheduleId, route, step) => {
    try {
      if (serviceDetails) {
        if (serviceDetails.total_available_seats > 0) {
          if (!step || step == 1) {
            // console.log(
            //   'CommonService.setSeatLayout(serviceDetails, route)',
            //   CommonService.setSeatLayout(serviceDetails, route),
            // );
            this.props.actions.setServiceOnward(CommonService.setSeatLayout(serviceDetails, route));
          } else {
            this.props.actions.setServiceReturn(CommonService.setSeatLayout(serviceDetails, route));
          }
          // CommonService.goToScreen(this.props.componentId,SERVICE_DETAILS_SCREEN,'Selecciona tu asiento')
        } else {
          this.setState({
            selectedServiceError: this.props.t('RESULTS_PAGE.SOLD_OUT_MSG'),
          });
          let list = JSON.parse(
            JSON.stringify(
              !step || step == 1 ? this.props.data.serviceList : this.props.data.serviceListReturn,
            ),
          );
          for (let i in list) {
            if (list[i].id == scheduleId) {
              list[i].available_seats = 0;
              !step || step == 1
                ? this.props.actions.setServiceListOnward(list)
                : this.props.actions.setServiceListReturn(list);
              break; //Stop this loop, we found it!
            }
          }
          this.setRoutes();
        }
      }
    } catch (e) {
      console.log(e);
    }
  };

  floorChange = floor => {
    this.setState({
      floor: floor,
    });
  };

  onSeatSelectOnward = (bookingDetails, reset = false) => {
    console.log('Booking details-------', bookingDetails);

    this.setState({ motMaxSeatError: false });
    if (this.props.home.is_mot && bookingDetails === 'MAX_SEATS_ERROR') {
      this.setState({
        motMaxSeatError: true,
        // showFilterModal: true,
        // showFilterModalMessage:this.props.t('PASSENGER_DETAILS.MOT_MAX_SEATS'),
      });
    }

    if (bookingDetails && bookingDetails.selectedSeatsNumbers) {
      seatsSelected = bookingDetails.selectedSeatsNumbers.split(',').length;
      // seatsSelected++;
    }

    let confirmTicketData = sessionStorage.getItem('confirmTicketData');

    // console.log(seatsSelected);
    sessionStorage.removeItem('paymentCounter');
    // console.log('Data is ', bookingDetails.selectedSeatsToBook ? bookingDetails.selectedSeatsToBook.length : "No Seats");
    if (
      bookingDetails.selectedSeatsToBook &&
      bookingDetails.selectedSeatsToBook.length <=
        ((this.props.pbServiceList.selectedService &&
          this.props.pbServiceList.selectedService.res_details &&
          this.props.pbServiceList.selectedService.res_details.no_of_seats_to_be_booked) ||
          8) &&
      (!confirmTicketData ||
        (bookingDetails.selectedSeatsToBook && bookingDetails.selectedSeatsToBook.length <= 1)) &&
      bookingDetails != 'NO_AVAILABLE'
    ) {
      this.props.actions.selectSeatOnward(bookingDetails);

      let selectedSeats = [];
      let homeData = this.props.home;

      if (
        bookingDetails.selectedSeatsToBook &&
        bookingDetails.selectedSeatsToBook.length &&
        this.props.pbServiceList &&
        this.props.pbServiceList.selectedServiceOnward &&
        this.props.pbServiceList.selectedServiceOnward.route
      ) {
        // bookingDetails.selectedSeatsToBook.map(val => {
        selectedSeats.push({
          // id: Number(bookingDetails.selectedSeatsToBook[0].number),
          name: CommonService.isTrain()
            ? 'train-'
            : 'bus-' + homeData.pbSourceCity.label + ' to ' + homeData.pbDestinationCity.label,
          price: bookingDetails.selectedSeatsToBook[0].net_amount,
          brand: this.props.pbServiceList.selectedServiceOnward.route.operator_service_name,
          category: CommonService.isTrain() ? 'train' : 'bus',
          variant: this.props.pbServiceList.selectedService.dep_time,
          position: bookingDetails.selectedSeatsToBook[0].row_id,
          quantity: bookingDetails.selectedSeatsToBook.length,
        });
        // });

        // console.log('testing selected Seats----', selectedSeats);

        CommonService.pushSelectedSeats(selectedSeats);
      }
      // console.log("Logged", "hello");
    } else if (
      (bookingDetails.selectedSeatsToBook &&
        bookingDetails.selectedSeatsToBook.length >=
          ((this.props.pbServiceList.selectedService &&
            this.props.pbServiceList.selectedService.res_details &&
            this.props.pbServiceList.selectedService.res_details.no_of_seats_to_be_booked) ||
            8)) ||
      (confirmTicketData &&
        bookingDetails.selectedSeatsToBook &&
        bookingDetails.selectedSeatsToBook.length >= 1)
    ) {
      // console.log('More than 8 seats');
      this.setState({
        showFilterModal: true,
        showFilterModalMessage: 'VALIDATIONS.MAX_SEAT_COUNT',
      });
    }
    if (reset) {
      this.props.actions.selectSeatOnward(bookingDetails);
    }

    // if(bookingDetails.selectedSeatsToBook){
    //   bookingDetails.selectedSeatsToBook.length == 8 ?
    // }
    // else
    // this.refs.toast.show('Máximo ' + this.props.data.bookingDetailsOnward.selectedSeatsToBook.length + ' asientos permitidos por compra');
  };

  onSeatSelectReturn = bookingDetails => {
    if (bookingDetails && bookingDetails.selectedSeatsNumbers) {
      seatsSelected = bookingDetails.selectedSeatsNumbers.split(',').length;
      // seatsSelected++;
    }

    console.log(seatsSelected);

    sessionStorage.removeItem('paymentCounter');
    // console.log('Data is ', bookingDetails.selectedSeatsToBook ? bookingDetails.selectedSeatsToBook.length : "No Seats");
    if (
      bookingDetails.selectedSeatsToBook &&
      bookingDetails.selectedSeatsToBook.length <=
        ((this.props.pbServiceList.selectedService.res_details &&
          this.props.pbServiceList.selectedService.res_details.no_of_seats_to_be_booked) ||
          8) &&
      bookingDetails != 'NO_AVAILABLE'
    ) {
      this.props.actions.selectSeatReturn(bookingDetails);
      // console.log("Logged", "hello");
    } else if (
      (bookingDetails.selectedSeatsToBook && bookingDetails.selectedSeatsToBook.length) >=
      ((this.props.pbServiceList.selectedService &&
        this.props.pbServiceList.selectedService.res_details &&
        this.props.pbServiceList.selectedService.res_details.no_of_seats_to_be_booked) ||
        8)
    ) {
      // console.log('More than 8 seats');
      this.setState({
        showFilterModal: true,
        showFilterModalMessage: 'VALIDATIONS.MAX_SEAT_COUNT',
      });
    }
  };

  releaseSeats = (service, data, step) => {
    this.setState({ confirmLoader: true });
    if (this.tripStep != 2) {
      sessionStorage.removeItem('preBlockResponseDataOnward');
    } else {
      sessionStorage.removeItem('preBlockResponseDataReturn');
    }

    console.log('Release seat api payload---', JSON.stringify(data));
    this.props.actions
      .apiCall({
        url: ApiUrls.preBlockReleaseBooking(),
        method: 'POST',
        data,
      })
      .then(
        res => {
          this.setState({ confirmLoader: false });
          console.log(res);
          this.onBookButtonPress(service, step);
        },
        err => {},
      );
  };

  checkReturnServiceAvailability = (service, step) => {
    if (
      // this.state.showNoReturnPopup &&
      this.state.all_service_schedules &&
      (this.state.all_service_schedules.return_schedules == null ||
        this.state.all_service_schedules.return_schedules.length < 1) &&
      this.journeyDateReturn != undefined
    ) {
      this.props.actions.setReturnPbDate(undefined);
      this.setState({
        showModal: true,
        modalTitle: this.props.t('HOME.WE_ARE_SORRY'),
        modalIcon: '/images/warning.png',
        modalBody: this.props.t('HOME.NO_RETURN_SERVICES'),
        // hideIcon: '/images/icons/close-window.svg',
        backdrop: false,
        showButton1: true,
        buttonText1: this.props.t('HOME.YES_CONTINUE'),
        onButtonClick1: () => {
          // this.setState({
          //   showNoReturnPopup: false,
          // })
          this.closeModal();
          this.continue(service, step);
        },
        showButton2: true,
        buttonText2: this.props.t('HOME.BACK_TO_HOME'),
        onButtonClick2: () => {
          this.closeModal();
          this.props.history.push('/');
        },
      });

      return;
    } else {
      this.continue(service, step);
    }
  };

  continue = (service, step) => {
    let isTSService = false;
    let isTSServiceRound = false;
    let preBlockApiCall = false;
    let preBlockApiCallReturn = false;

    let preblockOperators =
      this.props &&
      this.props.home &&
      this.props.home.metaData &&
      this.props.home.metaData.preblock_operators;

    let onwardRoute =
      this.props.pbServiceList &&
      this.props.pbServiceList.selectedServiceOnward &&
      this.props.pbServiceList.selectedServiceOnward.route;

    let returnRoute =
      this.props.pbServiceList &&
      this.props.pbServiceList.selectedServiceReturn &&
      this.props.pbServiceList.selectedServiceReturn.route;

    if (onwardRoute && preblockOperators.includes(onwardRoute.travel_id)) {
      preBlockApiCall = preblockOperators.includes(onwardRoute.travel_id);
    } else {
      preBlockApiCall = false;
    }
    if (returnRoute && preblockOperators.includes(returnRoute.travel_id)) {
      preBlockApiCallReturn = preblockOperators.includes(returnRoute.travel_id);
    } else {
      preBlockApiCallReturn = false;
    }

    if (
      this.props.pbServiceList &&
      this.props.pbServiceList.selectedServiceOnward &&
      this.props.pbServiceList.selectedServiceOnward.api_type
    ) {
      isTSService = this.props.pbServiceList.selectedServiceOnward.api_type === 1 ? true : false;

      sessionStorage.setItem('isTSService', isTSService);
    } else {
      sessionStorage.setItem('isTSService', false);
    }
    if (
      this.props.pbServiceList &&
      this.props.pbServiceList.selectedServiceReturn &&
      this.props.pbServiceList.selectedServiceReturn.api_type
    ) {
      isTSServiceRound =
        this.props.pbServiceList.selectedServiceReturn.api_type === 1 ? true : false;
      sessionStorage.setItem('isTSServiceRound', isTSServiceRound);
    } else {
      sessionStorage.setItem('isTSServiceRound', false);
    }

    // return;
    try {
      if (this.tripStep != 2) {
        if (
          !this.props.pbServiceList.bookingDetailsOnward ||
          !this.props.pbServiceList.bookingDetailsOnward.selectedSeatsToBook ||
          !this.props.pbServiceList.bookingDetailsOnward.selectedSeatsToBook.length
        ) {
          // this.refs.toast.show('Selecciona tu asiento');
          return;
        }
        if (
          !this.props.pbServiceList.selectedServiceOnward ||
          !this.props.pbServiceList.selectedServiceOnward.boardingStage
        ) {
          // this.refs.toast.show('Seleccione punto de embarque');
          this.setState({ boardingErrorMessage: 'Seleccione punto de embarque' });
          return;
        }
        if (
          !this.props.pbServiceList.selectedServiceOnward ||
          !this.props.pbServiceList.selectedServiceOnward.droppingStage
        ) {
          // this.refs.toast.show('Seleccione punto de llegada');
          this.setState({ droppingErrorMessage: 'Seleccione punto de llegada' });
          return;
        }
      } else {
        if (
          !this.props.pbServiceList.bookingDetailsReturn ||
          !this.props.pbServiceList.bookingDetailsReturn.selectedSeatsToBook ||
          !this.props.pbServiceList.bookingDetailsReturn.selectedSeatsToBook.length
        ) {
          // this.refs.toast.show('Selecciona tu asiento');
          return;
        }
        if (
          !this.props.pbServiceList.selectedServiceReturn ||
          !this.props.pbServiceList.selectedServiceReturn.boardingStage
        ) {
          // this.refs.toast.show('Seleccione punto de embarque');
          this.setState({ boardingErrorMessage: 'Seleccione punto de embarque' });
          return;
        }
        if (
          !this.props.pbServiceList.selectedServiceReturn ||
          !this.props.pbServiceList.selectedServiceReturn.droppingStage
        ) {
          // this.refs.toast.show('Seleccione punto de llegada');
          this.setState({ droppingErrorMessage: 'Seleccione punto de llegada' });
          return;
        }
      }
      this.setState({ boardingErrorMessage: null });
      this.setState({ droppingErrorMessage: null });
    } catch (e) {}

    let confirmTicketData = sessionStorage.getItem('confirmTicketData');
    if (confirmTicketData) {
      this.confirmTicket();
      return;
    }

    if (this.tripStep != 2 && preBlockApiCall) {
      this.callPreBlockAPI(service, step);
    } else if (this.tripStep == 2 && preBlockApiCallReturn) {
      this.callPreBlockAPI(service, step);
    } else {
      this.onContinueSuccess();
    }
  };

  callPreBlockAPI = (service, step) => {
    let seats = [];
    if (this.tripStep != 2) {
      sessionStorage.removeItem('preBlockResponseDataOnward');
      seats = this.props.pbServiceList.bookingDetailsOnward.selectedSeatsNumbers.split(',');
    } else {
      sessionStorage.removeItem('preBlockResponseDataReturn');
      seats = this.props.pbServiceList.bookingDetailsReturn.selectedSeatsNumbers.split(',');
    }
    let data = { request_hash: { schedule_id: service.id, seat_numbers: seats } };

    // console.log(data, this.props.pbServiceList.bookingDetailsOnward.selectedSeatsNumbers);

    this.setState({ confirmLoader: true });

    this.props.actions
      .apiCall({
        url: ApiUrls.preBlockBooking(),
        method: 'POST',
        data,
      })
      .then(
        res => {
          this.setState({ confirmLoader: false });
          // console.log(res);
          if (res && res.data && res.data.result && res.data.result.book_request_id) {
            // {this.props.t('RESULTS_PAGE.SOME_OF_THE_SELECTED_SEATS_ARE_NOT_AVAILABLE')}
            let status = true;
            let releaseSeat = false;
            // let data = {
            //   seat_code_hash: {},
            // };
            let data = {
              request_hash: { schedule_id: service.id, seat_numbers: seats, seat_code_hash: {} },
              book_request_id: res.data.result.book_request_id,
              // seat_code_hash: {},
            };
            if (res.data.result.block_resp) {
              for (let seat in res.data.result.block_resp) {
                if (res.data.result.block_resp[seat]) {
                  if (!res.data.result.block_resp[seat].estadoReserva) {
                    status = false;
                  }
                  if (res.data.result.block_resp[seat].codigoReserva) {
                    releaseSeat = true;
                    data.request_hash.seat_code_hash[(seat || '').substr(6)] = {
                      seat_code: res.data.result.block_resp[seat].codigoReserva,
                    };
                  }
                }
              }
            }
            if (status) {
              // let data = { "request_hash": { "schedule_id": service.id, "seat_numbers": seats }, "book_request_id": res.data.result.book_request_id };
              // data = {
              //   "1_5": {
              //     "seat_code": "3482266"

              //   }, "2_6": {
              //     "seat_code": "3482266"
              //   }
              // }
              let blockData = { releaseData: data, blockData: res.data.result };
              if (this.tripStep != 2)
                sessionStorage.setItem('preBlockResponseDataOnward', JSON.stringify(blockData));
              else sessionStorage.setItem('preBlockResponseDataReturn', JSON.stringify(blockData));
              this.onContinueSuccess();
            } else {
              this.setState({
                showSuccessModal: true,
                modalSuccess: false,
                modalBodyText: this.props.t(
                  'RESULTS_PAGE.SOME_OF_THE_SELECTED_SEATS_ARE_NOT_AVAILABLE',
                ),
              });
              // let data = { "request_hash": { "schedule_id": service.id, "seat_numbers": seats }, "book_request_id": res.data.result.book_request_id };
              if (releaseSeat) this.releaseSeats(service, data, step);
            }
          } else {
            this.setState({
              showSuccessModal: true,
              modalSuccess: false,
              modalBodyText: this.props.t(
                'RESULTS_PAGE.SOME_OF_THE_SELECTED_SEATS_ARE_NOT_AVAILABLE',
              ),
            });
            this.onBookButtonPress(service, step);
          }
        },
        err => {
          console.log('error data in cancel ticket -----', err);
          this.setState({
            showSuccessModal: true,
            modalSuccess: false,
            modalBodyText: this.props.t(
              'RESULTS_PAGE.SOME_OF_THE_SELECTED_SEATS_ARE_NOT_AVAILABLE',
            ),
          });
        },
      );
  };

  onContinueSuccess = () => {
    try {
      if (!this.props.home.returnPBDate) {
        CommonService.setLocal('pbServiceList', this.props.pbServiceList);

        let homeData = this.props.home;

        let pbServiceListData = this.props.pbServiceList;

        if (pbServiceListData && pbServiceListData.selectedServiceOnward) {
          let selectedSeatsToPush = {
            // id: 1, //Optional
            name: CommonService.isTrain()
              ? 'train'
              : 'bus' +
                '-' +
                homeData.pbSourceCity.label +
                ' to ' +
                homeData.pbDestinationCity.label, // Compulsory
            price: pbServiceListData.bookingDetailsOnward.netBookingAmount, // Price here should be No. of seats x per ticket price
            brand:
              pbServiceListData.selectedServiceOnward.route &&
              pbServiceListData.selectedServiceOnward.route.operator_service_name,
            category: CommonService.isTrain() ? 'train' : 'bus',
            variant: pbServiceListData.selectedServiceOnward.route.dep_time,
            quantity: pbServiceListData.bookingDetailsOnward.selectedSeatsToBook.length, // number of bus seats chosen
          };

          CommonService.pushSeatsAddedToCart(selectedSeatsToPush);
        }

        //GO to Payment Page logic
        let home = {
          onwardPBDate: this.props.home.onwardPBDate,
          pbSourceCity: this.props.home.pbSourceCity,
          pbDestinationCity: this.props.home.pbDestinationCity,
          metaData: this.props.home.metaData,
        };
        CommonService.setLocal('home', home);
        this.props.history.push(`/${i18next.language}/booking`);
      } else {
        if (this.tripStep == 1) {
          this.tripStep = 2;
          this.props.actions.setServiceListReturn(
            this.serviceListResponseFull.body.return_schedules,
          );
          this.props.actions.setServiceReturn({
            coachLayoutJson: null,
            originStageDetails: null,
            destinationStageDetails: null,
            boardingStage: null,
            droppingStage: null,
            route: null,
            selectedService: null,
          });
          this.setState({
            getServiceListPending: false,
          });
          this.routesRes = this.serviceListResponseFull.body.return_schedules;
          if (this.props.home.metaData) this.filtersAdded = true;
          this.createFilters(this.routesRes);

          this.props.history.push(
            `/${i18next.language}/${
              CommonService.isTrain()
                ? i18next.language == 'es'
                  ? 'pasajes-tren'
                  : 'train-tickets'
                : i18next.language == 'es'
                ? 'pasajes-bus'
                : 'bus-tickets'
            }/${this.originOnward}/${this.destOnward}/${this.journeyDateOnward}/${
              this.journeyDateReturn
            }/2`,
          );
          this.setupStepMenu(2, 2);
        } else {
          CommonService.setLocal('pbServiceList', this.props.pbServiceList);

          let pbServiceListData = this.props.pbServiceList;

          if (pbServiceListData && pbServiceListData.selectedServiceOnward) {
            let selectedSeatsToPush = {
              id: 1, //Optional
              name:
                pbServiceListData.selectedServiceOnward.route &&
                pbServiceListData.selectedServiceOnward.route.operator_service_name +
                  '-' +
                  pbServiceListData.selectedServiceOnward.route.fare_str, // Compulsory
              price: pbServiceListData.bookingDetailsOnward.netBookingAmount, // Price here should be No. of seats x per ticket price
              brand:
                pbServiceListData.selectedServiceOnward.route &&
                pbServiceListData.selectedServiceOnward.route.operator_service_name,
              category: CommonService.isTrain() ? 'train' : 'bus',
              variant:
                pbServiceListData.selectedServiceOnward.route &&
                pbServiceListData.selectedServiceOnward.route.dep_time,
              quantity: pbServiceListData.bookingDetailsOnward.selectedSeatsToBook.length, // number of bus seats chosen
            };

            CommonService.pushSeatsAddedToCart(selectedSeatsToPush);
          }

          let home = {
            onwardPBDate: this.props.home.onwardPBDate,
            returnPBDate: this.props.home.returnPBDate,
            pbSourceCity: this.props.home.pbSourceCity,
            pbDestinationCity: this.props.home.pbDestinationCity,
            metaData: this.props.home.metaData,
          };
          CommonService.setLocal('home', home);
          this.props.history.push(`/${i18next.language}/booking`);
        }
      }
    } catch (e) {
      console.log(e);
    }
  };

  renderSelectedSearchBox = () => {
    const { t } = this.props;
    return (
      <div className="content-container">
        <div className="selected-search-box">
          <div className="selected-search-values font10">
            <div className="selected-search-item">
              <span className="selected-search-label">{t('HOME.ORIGIN')}</span>
              <span className="selected-search-value">
                {this.props.home.pbSourceCity && this.props.home.pbSourceCity.label}
              </span>
            </div>
            <div className="selected-search-item">
              <span className="selected-search-label">{t('HOME.DESTINATION')}</span>
              <span className="selected-search-value">
                {this.props.home.pbDestinationCity && this.props.home.pbDestinationCity.label}
              </span>
            </div>
            <div className="selected-search-item">
              <span className="selected-search-label">{t('HOME.GOING')}</span>
              <span className="selected-search-value">
                {DateService.getDayNameFromDate(this.props.home.onwardPBDate) +
                  ', ' +
                  DateService.getDateFromDate(this.props.home.onwardPBDate) +
                  ' ' +
                  DateService.getMonthNameFromDate(this.props.home.onwardPBDate)}
              </span>
            </div>
            {this.props.home.returnPBDate ? (
              <div className="selected-search-item">
                <span className="selected-search-label">{t('HOME.RETURN')}</span>
                <span className="selected-search-value">
                  {DateService.getDayNameFromDate(this.props.home.returnPBDate) +
                    ', ' +
                    DateService.getDateFromDate(this.props.home.returnPBDate) +
                    ' ' +
                    DateService.getMonthNameFromDate(this.props.home.returnPBDate)}
                </span>
              </div>
            ) : null}
          </div>
          <div className="new-search-button font12">
            <a
              className="new-search-button-a kupos-button-secondary"
              onClick={() => this.setState({ openNewSearch: !this.state.openNewSearch })}
            >
              NUEVA BÚSQUEDA{' '}
            </a>
            <span>
              <img src="/images/icons/home/icon_arrow_down_white.png" />
            </span>
          </div>
        </div>
      </div>
    );
  };

  newSearch = () => {
    try {
      this.serviceLoaded = false;
      this.setState({
        serviceList: '',
      });
      let newHeaderSearch = document.querySelector('.nav-section .common-new-search-box');
      if (newHeaderSearch) newHeaderSearch.style.display = 'block';
      this.props.actions.setSelectedService(null);
      this.props.actions.setServiceListOnward(null);
      this.props.actions.setServiceListReturn(null);
      this.originOnward = this.props.home.pbSourceCity
        ? this.props.home.pbSourceCity.label
            .toLowerCase()
            .replace(/-/g, '_')
            .replace(/ /g, '-')
            .replace(/_/g, '--')
        : '';
      this.destOnward = this.props.home.pbDestinationCity
        ? this.props.home.pbDestinationCity.label
            .toLowerCase()
            .replace(/-/g, '_')
            .replace(/ /g, '-')
            .replace(/_/g, '--')
        : '';
      this.journeyDateOnward = this.props.home.onwardPBDate;
      if (this.tripStep == 1) {
        this.journeyDateReturn = this.props.home.returnPBDate;
      }
      this.setState({
        filtersArray: filtersArray,
      });
      if (!this.props.home.returnPBDate) {
        this.props.history.push(
          `/${i18next.language}/${
            CommonService.isTrain()
              ? i18next.language == 'es'
                ? 'pasajes-tren'
                : 'train-tickets'
              : i18next.language == 'es'
              ? 'pasajes-bus'
              : 'bus-tickets'
          }/${this.originOnward}/${this.destOnward}/${this.props.home.onwardPBDate}`,
        );
        this.loadServices(
          this.props.home.pbSourceCity.value,
          this.props.home.pbDestinationCity.value,
          DateService.changeDateFormat(this.props.home.onwardPBDate, 'dd-mm-yyyy', 'yyyy-mm-dd'),
        );
      } else {
        this.props.history.push(
          `/${i18next.language}/${
            CommonService.isTrain()
              ? i18next.language == 'es'
                ? 'pasajes-tren'
                : 'train-tickets'
              : i18next.language == 'es'
              ? 'pasajes-bus'
              : 'bus-tickets'
          }/${this.originOnward}/${this.destOnward}/${this.props.home.onwardPBDate}/${
            this.props.home.returnPBDate
          }/1`,
        );
        this.loadServices(
          this.props.home.pbSourceCity.value,
          this.props.home.pbDestinationCity.value,
          DateService.changeDateFormat(this.props.home.onwardPBDate, 'dd-mm-yyyy', 'yyyy-mm-dd'),
        );
      }
    } catch (e) {
      console.log(e);
    }
  };

  onFilterSelected = (option, key, i) => {
    console.log('Filters option are----', option);
    console.log('Filters key are----', key);
    console.log('Filters i are----', i);
    let filters = CommonService.copyObject(this.state.filtersArray);
    filters[key].options[i].active = !filters[key].options[i].active;
    this.filterBy(filters, key);
    this.setState({
      filtersArray: filters,
    });
    // setTimeout(() => {
    //   if(this.isFilterSelected()){
    //     console.log('this.state.serviceList',this.state.serviceList)
    //     if(!this.state.serviceList || !this.state.serviceList || !this.state.serviceList.length){
    //       this.setState({ showFilterModal : true, showFilterModalMessage:"You cannot select more than 8 seats", filterSelected:true});
    //     }
    //   }
    // },300)
  };

  filterBy(filters, key) {
    try {
      let routes;
      if (this.tripStep == 2) {
        routes = CommonService.copyObject(this.props.pbServiceList.serviceListReturn);
      } else {
        routes = CommonService.copyObject(this.props.pbServiceList.serviceList);
      }
      let filteredRoutes = [];
      for (let fil of filters) {
        if (fil.type == 'time') {
          let activeOptions = fil.options.filter(it => it.active);
          filteredRoutes = routes.filter(it => {
            for (let f of fil.options) {
              if (activeOptions && activeOptions.length) {
                if (f.active) {
                  if (f.value == 'sunrise' && it.dep_time < '06:00') {
                    return true;
                  } else if (
                    f.value == 'morning' &&
                    it.dep_time >= '06:00' &&
                    it.dep_time < '12:00'
                  ) {
                    return true;
                  } else if (
                    f.value == 'sunset' &&
                    it.dep_time >= '12:00' &&
                    it.dep_time < '18:00'
                  ) {
                    return true;
                  } else if (f.value == 'night' && it.dep_time >= '18:00') {
                    return true;
                  }
                }
              } else {
                return true;
              }
            }
          });
        }
        if (fil.type == 'operator') {
          let activeOptions = fil.options.filter(it => it.active);
          filteredRoutes = filteredRoutes.filter(it => {
            for (let f of fil.options) {
              if (activeOptions && activeOptions.length) {
                if (f.active) {
                  if (it.operator_service_name.toLowerCase().indexOf(f.value.toLowerCase()) >= 0) {
                    return true;
                  }
                }
              } else {
                return true;
              }
            }
          });
        }
        if (fil.type == 'amenities') {
          let activeOptions = fil.options.filter(it => it.active);
          filteredRoutes = filteredRoutes.filter(it => {
            for (let f of fil.options) {
              if (activeOptions && activeOptions.length) {
                if (f.active) {
                  if (f.value == 'pet') {
                    if (it.pet_seat_info && Object.keys(it.pet_seat_info || []).length > 0) {
                      return true;
                    }
                  }
                  if (it.operator_details[4]) {
                    for (let a of it.operator_details[4]) {
                      let am = this.props.home.metaData.amenities[a].split('.')[0].toLowerCase();
                      if (am.indexOf(f.value.toLowerCase()) >= 0) {
                        return true;
                      }
                    }
                  }
                }
              } else {
                return true;
              }
            }
          });
        }
        if (fil.type == 'seat_types') {
          let activeOptions = fil.options.filter(it => it.active);
          filteredRoutes = filteredRoutes.filter(it => {
            for (let f of fil.options) {
              if (activeOptions && activeOptions.length) {
                if (f.active) {
                  if (f.value.toLowerCase().indexOf('semi') > -1) {
                    for (let bt of it.fare_str.split(',')) {
                      if (
                        bt
                          .toLowerCase()
                          .split(':')[0]
                          .indexOf('semi') > -1
                      ) {
                        return true;
                      }
                    }
                  } else if (f.value.toLowerCase().indexOf('salon') > -1) {
                    for (let bt of it.fare_str.split(',')) {
                      if (
                        bt
                          .toLowerCase()
                          .split(':')[0]
                          .indexOf('salon') > -1
                      ) {
                        return true;
                      }
                    }
                  } else if (f.value.toLowerCase().indexOf('ejecutivo') > -1) {
                    for (let bt of it.fare_str.split(',')) {
                      if (
                        bt
                          .toLowerCase()
                          .split(':')[0]
                          .indexOf('ejecutivo') > -1
                      ) {
                        return true;
                      }
                    }
                  } else if (f.value.toLowerCase().indexOf('suite') > -1) {
                    for (let bt of it.fare_str.split(',')) {
                      if (
                        bt
                          .toLowerCase()
                          .split(':')[0]
                          .indexOf('suite') > -1
                      ) {
                        return true;
                      }
                    }
                  } else if (f.value.toLowerCase().indexOf('vip') > -1) {
                    for (let bt of it.fare_str.split(',')) {
                      if (
                        bt
                          .toLowerCase()
                          .split(':')[0]
                          .indexOf('vip') > -1
                      ) {
                        return true;
                      }
                    }
                  } else if (f.value.toLowerCase() == 'cama') {
                    for (let bt of it.fare_str.split(',')) {
                      if (bt.toLowerCase().split(':')[0] == 'cama') {
                        return true;
                      }
                    }
                  } else if (f.value.toLowerCase() == 'preferente') {
                    for (let bt of it.fare_str.split(',')) {
                      if (bt.toLowerCase().split(':')[0] == 'preferente') {
                        return true;
                      }
                    }
                  } else if (f.value.toLowerCase().indexOf('vent') > -1) {
                    for (let bt of it.fare_str.split(',')) {
                      if (
                        bt
                          .toLowerCase()
                          .split(':')[0]
                          .indexOf('vent') > -1
                      ) {
                        return true;
                      }
                    }
                  } else if (f.value.toLowerCase().indexOf('clasico') > -1) {
                    for (let bt of it.fare_str.split(',')) {
                      if (
                        bt
                          .toLowerCase()
                          .split(':')[0]
                          .indexOf('clasico') > -1
                      ) {
                        return true;
                      }
                    }
                  }
                  //  if (type.toLowerCase() == 'clasico') {
                  //   type2 = 'Clásico';
                  // }

                  // if(it.bus_type.split(' ').join('-').toLowerCase().indexOf(f.value.toLowerCase()) >= 0){
                  //   return true
                  // }
                }
              } else {
                return true;
              }
            }
          });
        }
      }
      routes = filteredRoutes;
      this.setState({
        serviceList: routes,
      });
      // console.log('Routes List', this.state.serviceList);
    } catch (e) {
      console.log(e);
    }
  }

  renderServiceLoader = () => {
    return (
      <div className="service-loader center-text">
        <span>
          <img className="animation-gif" src="/images/animations/animation.gif" alt="img" />
          <div style={{ marginTop: 10, marginBottom: 20 }}>
            <span className="grey-text font12">{this.props.t('TRANSLATIONS.LOADING_MESSAGE')}</span>
          </div>
        </span>
      </div>
    );
  };

  closeLayout = step => {
    this.clearSelectedSeats(step);
    this.props.actions.setSelectedService(null);
  };

  isFilterSelected = () => {
    for (let f of this.state.filtersArray) {
      for (let o of f.options) {
        if (o.active) {
          return true;
        }
      }
    }
    return false;
  };

  clearFilter = () => {
    let filters = CommonService.copyObject(this.state.filtersArray);
    for (let f of filters) {
      for (let o of f.options) {
        o.active = false;
      }
    }
    this.setState({ filtersArray: filters, filterSelected: false });
    this.filterBy(filters);
  };

  closeModal = () => {
    this.setState({
      showModal: false,
      modalTitle: '',
      modalBody: '',
      onButtonClick1: null,
      showButton2: false,
      buttonText2: null,
      modalIcon: null,
      modalChild: null,
      showCloseIcon: false,
    });
  };

  confirmTicket = () => {
    console.log('hello');
    this.setState({ confirmLoader: true });
    let confirmTicketData = JSON.parse(sessionStorage.getItem('confirmTicketData'));
    let data = {
      res_details: this.props.pbServiceList.selectedService.res_details,
      pnr_number: confirmTicketData.boleto,
      seat_no: this.props.pbServiceList.bookingDetailsOnward.selectedSeatsNumbers,
      email: confirmTicketData.email,
      travel_date: confirmTicketData.tentative_date,
    };
    this.props.actions
      .apiCall({
        url: ApiUrls.confirmTicket(),
        method: 'POST',
        data,
      })
      .then(
        res => {
          this.setState({ confirmLoader: false });
          console.log(res);
          if (res && res.data && res.data.success) {
            sessionStorage.setItem(
              'confirmTicketDataResponse',
              JSON.stringify({
                // result: {
                //   voucher: {
                //     origin_name: res.data.origin_name,
                //     destination_name: res.data.destination_name,
                //   },
                // },
                ...res.data,
                origin_name: this.originCityDecoded,
                destination_name: this.destCityDecoded,
              }),
            );
            this.props.history.push(`/${i18next.language}/confirm-ticket-response`);
          } else {
            this.setState({ confirmLoader: false });
            sessionStorage.setItem(
              'confirmTicketDataResponse',
              JSON.stringify({
                success: false,
              }),
            );

            this.setState({
              showSuccessModal: true,
              modalSuccess: false,
              // modalBodyText: this.props.t('CANCEL_TICKET.INVALID_PNR_AT'),
              modalBodyText: res.data
                ? res.data.message
                : this.props.t('CANCEL_TICKET.INVALID_PNR_AT'),
              // modalBodyText: res.data ? res.data.message : res.statusText,
            });

            // this.props.history.push(`/${i18next.language}/change-ticket-response`);
          }
        },
        err => {
          console.log('error data in cancel ticket -----', err);
          this.setState({
            showSuccessModal: true,
            modalSuccess: false,
            confirmLoader: false,
            modalBodyText: err.data
              ? err.data.message
              : this.props.t('CANCEL_TICKET.INVALID_PNR_AT'),
            // modalBodyText: err.data ? err.data.message : err.statusText,
          });
          sessionStorage.setItem('confirmTicketDataResponse', JSON.stringify(err.data));
          //show popup here
          // this.props.history.push(`/${i18next.language}/change-ticket-response`);
        },
      );
  };

  renderServicePageBody = () => {
    return (
      <div className="content-container services-main-container">
        <ServiceFilter
          t={this.props.t}
          filtersArray={this.state.filtersArray}
          onFilterSelected={this.onFilterSelected}
          onFilterClear={val => {
            this.setState({ filtersArray: val });
            this.filterBy(val);
          }}
        />
        <div className="services-list-container">
          <KuposCapsuleMenu
            t={this.props.t}
            menuButtons={this.capsuleMenuIcons}
            tab={true}
            activeTab={this.state.activeSortTab}
            onTabChange={i => this.sortBy(i)}
            showSortIcon={true}
            sortType={this.state.orderBy}
          />

          <div className="service-cards-container">
            {/* {console.log(
              'Service List rendered-------#######',
              this.state.serviceList.length,
            )} */}
            {/* {console.log('this.props.pbServiceList.selectedServiceOnward.boardingStage')} */}
            {(!this.tripStep || this.tripStep == 1) &&
            this.props.pbServiceList.serviceList &&
            this.props.pbServiceList.selectedServiceOnward &&
            this.state.serviceList &&
            this.state.serviceList &&
            this.props.home
              ? this.state.serviceList.map((val, key) => {
                  return val.available_seats > 0 &&
                    (val.travel_id == this.operatorId || !this.operatorId) ? (
                    <ServiceItem
                      key={key}
                      t={this.props.t}
                      serviceItem={val}
                      metaData={this.props.home.metaData}
                      otherDate={this.props.pbServiceList.bookingDetailsOnward}
                      onBookButtonPress={() => this.checkMidnight(val, 1)}
                      terminals={this.props.home.terminals}
                      seatsCleared={this.state.seatsCleared}
                      stagesData={this.props.home.allStages ? this.props.home.allStages : null}
                    >
                      {!this.state.selectedServiceError &&
                      this.props.pbServiceList.selectedService &&
                      this.props.pbServiceList.selectedServiceOnward.coachLayoutJson &&
                      this.props.pbServiceList.selectedService.id == val.id ? (
                        <SelectedServiceMore
                          key={
                            (this.props.pbServiceList.selectedServiceReturn.droppingStage
                              ? this.props.pbServiceList.selectedServiceReturn.droppingStage.id
                              : '') +
                            (this.props.pbServiceList.selectedServiceOnward.boardingStage
                              ? this.props.pbServiceList.selectedServiceOnward.boardingStage.id
                              : '') +
                            (this.props.pbServiceList.selectedServiceReturn.originStageDetails
                              ? this.props.pbServiceList.selectedServiceReturn.originStageDetails
                                  .length
                              : '') +
                            (this.props.pbServiceList.selectedServiceReturn.destinationStageDetails
                              ? this.props.pbServiceList.selectedServiceReturn
                                  .destinationStageDetails.length
                              : '')
                          }
                          boardingOptions={
                            this.props.pbServiceList.selectedServiceOnward.originStageDetails
                          }
                          droppingOptions={
                            this.props.pbServiceList.selectedServiceOnward.destinationStageDetails
                          }
                          selectedBoarding={
                            this.props.pbServiceList.selectedServiceOnward.boardingStage
                          }
                          selectedDropping={
                            this.props.pbServiceList.selectedServiceOnward.droppingStage
                          }
                          onBoardingPointChange={this.onBoardingPointChange}
                          onDroppingPointChange={this.onDroppingPointChange}
                          metaData={this.props.home.metaData}
                          coachLayout={
                            this.props.pbServiceList.selectedServiceOnward.coachLayoutJson
                          }
                          upperAvalibility={
                            this.props.pbServiceList.selectedServiceOnward.upperAvalibility
                          }
                          selectedSeatsToBook={
                            this.props.pbServiceList.bookingDetailsOnward
                              ? this.props.pbServiceList.bookingDetailsOnward.selectedSeatsToBook
                              : null
                          }
                          onFloorChange={floor => this.floorChange(floor)}
                          selectedFloor={this.state.floor}
                          onSeatSelect={seat => this.onSeatSelectOnward(seat)}
                          onContinueButtonClick={() => this.checkReturnServiceAvailability(val, 1)}
                          bookingDetails={this.props.pbServiceList.bookingDetailsOnward}
                          t={this.props.t}
                          closeLayout={() => this.closeLayout(1)}
                          serviceType={this.props.home.pbSetType}
                          boardingErrorMessage={this.state.boardingErrorMessage}
                          droppingErrorMessage={this.state.droppingErrorMessage}
                          selectedService={this.props.pbServiceList.selectedServiceOnward}
                          serviceDetails={val}
                          petSeats={this.state.petSeats}
                          confirmLoader={this.state.confirmLoader}
                          isMot={this.props.home.is_mot}
                          motMaxSeatError={this.state.motMaxSeatError}
                        />
                      ) : null}

                      {this.props.pbServiceList.getSelectedServicePending &&
                      this.state.selectedService &&
                      this.state.selectedService.id == val.id ? (
                        <div className="service-card-more-details">
                          {this.renderServiceLoader()}
                        </div>
                      ) : null}

                      {this.state.selectedServiceError &&
                      this.state.selectedService &&
                      this.state.selectedService.id == val.id ? (
                        <div className="service-card-more-details">
                          <span className="service-error-msg">
                            {this.state.selectedServiceError}
                          </span>
                        </div>
                      ) : null}
                    </ServiceItem>
                  ) : null;
                })
              : null}
            {(!this.tripStep || this.tripStep == 1) &&
            this.props.pbServiceList.serviceList &&
            this.props.pbServiceList.selectedServiceOnward &&
            this.state.serviceList &&
            this.state.serviceList
              ? this.state.serviceList.map((val, key) => {
                  return val.available_seats <= 0 &&
                    (val.travel_id == this.operatorId || !this.operatorId) ? (
                    <ServiceItem
                      key={key}
                      t={this.props.t}
                      serviceItem={val}
                      metaData={this.props.home.metaData}
                      otherDate={this.props.pbServiceList.bookingDetailsOnward}
                      onBookButtonPress={() => this.checkMidnight(val, 1)}
                      stagesData={this.props.home.allStages ? this.props.home.allStages : null}
                    >
                      {!this.state.selectedServiceError &&
                      this.props.pbServiceList.selectedService &&
                      this.props.pbServiceList.selectedServiceOnward.coachLayoutJson &&
                      this.props.pbServiceList.selectedService.id == val.id ? (
                        <SelectedServiceMore
                          key={
                            (this.props.pbServiceList.selectedServiceReturn.droppingStage
                              ? this.props.pbServiceList.selectedServiceReturn.droppingStage.id
                              : '') +
                            (this.props.pbServiceList.selectedServiceOnward.boardingStage
                              ? this.props.pbServiceList.selectedServiceOnward.boardingStage.id
                              : '') +
                            (this.props.pbServiceList.selectedServiceReturn.originStageDetails
                              ? this.props.pbServiceList.selectedServiceReturn.originStageDetails
                                  .length
                              : '') +
                            (this.props.pbServiceList.selectedServiceReturn.destinationStageDetails
                              ? this.props.pbServiceList.selectedServiceReturn
                                  .destinationStageDetails.length
                              : '')
                          }
                          boardingOptions={
                            this.props.pbServiceList.selectedServiceOnward.originStageDetails
                          }
                          droppingOptions={
                            this.props.pbServiceList.selectedServiceOnward.destinationStageDetails
                          }
                          selectedBoarding={
                            this.props.pbServiceList.selectedServiceOnward.boardingStage
                          }
                          selectedDropping={
                            this.props.pbServiceList.selectedServiceOnward.droppingStage
                          }
                          onBoardingPointChange={this.onBoardingPointChange}
                          onDroppingPointChange={this.onDroppingPointChange}
                          metaData={this.props.home.metaData}
                          coachLayout={
                            this.props.pbServiceList.selectedServiceOnward.coachLayoutJson
                          }
                          upperAvalibility={
                            this.props.pbServiceList.selectedServiceOnward.upperAvalibility
                          }
                          selectedSeatsToBook={
                            this.props.pbServiceList.bookingDetailsOnward
                              ? this.props.pbServiceList.bookingDetailsOnward.selectedSeatsToBook
                              : null
                          }
                          onFloorChange={floor => this.floorChange(floor)}
                          selectedFloor={this.state.floor}
                          onSeatSelect={seat => this.onSeatSelectOnward(seat)}
                          onContinueButtonClick={() => this.checkReturnServiceAvailability(val, 1)}
                          bookingDetails={this.props.pbServiceList.bookingDetailsOnward}
                          t={this.props.t}
                          closeLayout={() => this.closeLayout(1)}
                          boardingErrorMessage={this.state.boardingErrorMessage}
                          droppingErrorMessage={this.state.droppingErrorMessage}
                          selectedService={this.props.pbServiceList.selectedServiceOnward}
                          serviceDetails={val}
                          petSeats={this.state.petSeats}
                          confirmLoader={this.state.confirmLoader}
                        />
                      ) : null}

                      {this.props.pbServiceList.getSelectedServicePending &&
                      this.state.selectedService &&
                      this.state.selectedService.id == val.id ? (
                        <div className="service-card-more-details">
                          {this.renderServiceLoader()}
                        </div>
                      ) : null}

                      {this.state.selectedServiceError &&
                      this.state.selectedService &&
                      this.state.selectedService.id == val.id ? (
                        <div className="service-card-more-details">
                          <span className="service-error-msg">
                            {this.state.selectedServiceError}
                          </span>
                        </div>
                      ) : null}
                    </ServiceItem>
                  ) : null;
                })
              : null}
            {this.tripStep == 2 &&
            this.props.pbServiceList.serviceListReturn &&
            this.props.pbServiceList.selectedServiceReturn &&
            this.state.serviceList &&
            this.state.serviceList
              ? this.state.serviceList.map((val, key) => {
                  return val.available_seats > 0 ? (
                    <ServiceItem
                      key={key}
                      t={this.props.t}
                      serviceItem={val}
                      metaData={this.props.home.metaData}
                      onBookButtonPress={() => this.checkMidnight(val, 2)}
                      stagesData={this.props.home.allStages ? this.props.home.allStages : null}
                    >
                      {!this.state.selectedServiceError &&
                      this.props.pbServiceList.selectedService &&
                      this.props.pbServiceList.selectedServiceReturn.coachLayoutJson &&
                      this.props.pbServiceList.selectedService.id == val.id ? (
                        <SelectedServiceMore
                          key={
                            (this.props.pbServiceList.selectedServiceReturn.droppingStage
                              ? this.props.pbServiceList.selectedServiceReturn.droppingStage.id
                              : '') +
                            (this.props.pbServiceList.selectedServiceOnward.boardingStage
                              ? this.props.pbServiceList.selectedServiceOnward.boardingStage.id
                              : '') +
                            (this.props.pbServiceList.selectedServiceReturn.originStageDetails
                              ? this.props.pbServiceList.selectedServiceReturn.originStageDetails
                                  .length
                              : '') +
                            (this.props.pbServiceList.selectedServiceReturn.destinationStageDetails
                              ? this.props.pbServiceList.selectedServiceReturn
                                  .destinationStageDetails.length
                              : '')
                          }
                          boardingOptions={
                            this.props.pbServiceList.selectedServiceReturn.originStageDetails
                          }
                          droppingOptions={
                            this.props.pbServiceList.selectedServiceReturn.destinationStageDetails
                          }
                          selectedBoarding={
                            this.props.pbServiceList.selectedServiceReturn.boardingStage
                          }
                          selectedDropping={
                            this.props.pbServiceList.selectedServiceReturn.droppingStage
                          }
                          onBoardingPointChange={this.onBoardingPointChange}
                          onDroppingPointChange={this.onDroppingPointChange}
                          metaData={this.props.home.metaData}
                          coachLayout={
                            this.props.pbServiceList.selectedServiceReturn.coachLayoutJson
                          }
                          upperAvalibility={
                            this.props.pbServiceList.selectedServiceReturn.upperAvalibility
                          }
                          selectedSeatsToBook={
                            this.props.pbServiceList.bookingDetailsReturn
                              ? this.props.pbServiceList.bookingDetailsReturn.selectedSeatsToBook
                              : null
                          }
                          onFloorChange={floor => this.floorChange(floor)}
                          selectedFloor={this.state.floor}
                          onSeatSelect={seat => this.onSeatSelectReturn(seat)}
                          onContinueButtonClick={() => this.continue(val, 2)}
                          bookingDetails={this.props.pbServiceList.bookingDetailsReturn}
                          t={this.props.t}
                          closeLayout={() => this.closeLayout(2)}
                          boardingErrorMessage={this.state.boardingErrorMessage}
                          droppingErrorMessage={this.state.droppingErrorMessage}
                          selectedService={this.props.pbServiceList.selectedServiceReturn}
                          serviceDetails={val}
                          petSeats={this.state.petSeats}
                          confirmLoader={this.state.confirmLoader}
                        />
                      ) : null}

                      {this.props.pbServiceList.getSelectedServicePending &&
                      this.state.selectedService &&
                      this.state.selectedService.id == val.id ? (
                        <div className="service-card-more-details">
                          {this.renderServiceLoader()}
                        </div>
                      ) : null}

                      {this.state.selectedServiceError &&
                      this.state.selectedService &&
                      this.state.selectedService.id == val.id ? (
                        <div className="service-card-more-details">
                          <span className="service-error-msg">
                            {this.state.selectedServiceError}
                          </span>
                        </div>
                      ) : null}
                    </ServiceItem>
                  ) : null;
                })
              : null}
            {this.tripStep == 2 &&
            this.props.pbServiceList.serviceListReturn &&
            this.props.pbServiceList.selectedServiceReturn &&
            this.state.serviceList &&
            this.state.serviceList
              ? this.state.serviceList.map((val, key) => {
                  return val.available_seats <= 0 ? (
                    <ServiceItem
                      key={key}
                      t={this.props.t}
                      serviceItem={val}
                      metaData={this.props.home.metaData}
                      onBookButtonPress={() => this.checkMidnight(val, 2)}
                      stagesData={this.props.home.allStages ? this.props.home.allStages : null}
                    >
                      {!this.state.selectedServiceError &&
                      this.props.pbServiceList.selectedService &&
                      this.props.pbServiceList.selectedServiceReturn.coachLayoutJson &&
                      this.props.pbServiceList.selectedService.id == val.id ? (
                        <SelectedServiceMore
                          key={
                            (this.props.pbServiceList.selectedServiceReturn.droppingStage
                              ? this.props.pbServiceList.selectedServiceReturn.droppingStage.id
                              : '') +
                            (this.props.pbServiceList.selectedServiceOnward.boardingStage
                              ? this.props.pbServiceList.selectedServiceOnward.boardingStage.id
                              : '') +
                            (this.props.pbServiceList.selectedServiceReturn.originStageDetails
                              ? this.props.pbServiceList.selectedServiceReturn.originStageDetails
                                  .length
                              : '') +
                            (this.props.pbServiceList.selectedServiceReturn.destinationStageDetails
                              ? this.props.pbServiceList.selectedServiceReturn
                                  .destinationStageDetails.length
                              : '')
                          }
                          boardingOptions={
                            this.props.pbServiceList.selectedServiceReturn.originStageDetails
                          }
                          droppingOptions={
                            this.props.pbServiceList.selectedServiceReturn.destinationStageDetails
                          }
                          selectedBoarding={
                            this.props.pbServiceList.selectedServiceReturn.boardingStage
                          }
                          selectedDropping={
                            this.props.pbServiceList.selectedServiceReturn.droppingStage
                          }
                          onBoardingPointChange={this.onBoardingPointChange}
                          onDroppingPointChange={this.onDroppingPointChange}
                          metaData={this.props.home.metaData}
                          coachLayout={
                            this.props.pbServiceList.selectedServiceReturn.coachLayoutJson
                          }
                          upperAvalibility={
                            this.props.pbServiceList.selectedServiceReturn.upperAvalibility
                          }
                          selectedSeatsToBook={
                            this.props.pbServiceList.bookingDetailsReturn
                              ? this.props.pbServiceList.bookingDetailsReturn.selectedSeatsToBook
                              : null
                          }
                          onFloorChange={floor => this.floorChange(floor)}
                          selectedFloor={this.state.floor}
                          onSeatSelect={seat => this.onSeatSelectReturn(seat)}
                          onContinueButtonClick={() => this.continue(val, 2)}
                          bookingDetails={this.props.pbServiceList.bookingDetailsReturn}
                          t={this.props.t}
                          closeLayout={() => this.closeLayout(2)}
                          boardingErrorMessage={this.state.boardingErrorMessage}
                          droppingErrorMessage={this.state.droppingErrorMessage}
                          selectedService={this.props.pbServiceList.selectedServiceReturn}
                          serviceDetails={val}
                          petSeats={this.state.petSeats}
                          confirmLoader={this.state.confirmLoader}
                        />
                      ) : null}

                      {this.props.pbServiceList.getSelectedServicePending &&
                      this.state.selectedService &&
                      this.state.selectedService.id == val.id ? (
                        <div className="service-card-more-details">
                          {this.renderServiceLoader()}
                        </div>
                      ) : null}

                      {this.state.selectedServiceError &&
                      this.state.selectedService &&
                      this.state.selectedService.id == val.id ? (
                        <div className="service-card-more-details">
                          <span className="service-error-msg">
                            {this.state.selectedServiceError}
                          </span>
                        </div>
                      ) : null}
                    </ServiceItem>
                  ) : null;
                })
              : null}
          </div>

          {/* {console.log('Service list available', this.state.serviceList)} */}

          {this.props.serviceList && this.state.serviceList.length < 1 ? (
            <div className="content-container cancel-done-section">
              <div className="cancel-ticket-done">
                <img src={'/images/icons/circular-icons/icon-failure.png'} alt="" />
              </div>

              <div className="mt-y-3 cancel-ticket-done">
                <span className="bold-text font20">{this.props.t('HOME.WE_ARE_SORRY')}</span>
              </div>

              <div className="mt-y-3 cancel-ticket-done cancel-ticket-done-desc font12">
                <span style={{ textAlign: 'center' }}>
                  {'No tenemos servicios disponibles con las características que seleccionaste.'}
                </span>
              </div>

              <div className="cancel-success-info-container">
                <div className="mt-y-3 cancel-ticket-done cancel-success-info-div-no-results font12">
                  <span className="primary-triangle"></span>
                  <span>{'Por favor intenta eliminando los filtros.'} </span>
                </div>
              </div>
            </div>
          ) : null}
        </div>
      </div>
    );
  };

  renderPaymentLoadingDiv = () => {
    return (
      <div className="payment-loader content-container">
        <span>Loader</span>
      </div>
    );
  };

  swapCities = () => {
    let source = CommonService.copyObject(this.props.home.pbSourceCity);
    let dest = CommonService.copyObject(this.props.home.pbDestinationCity);
    this.props.actions.pbSetSourceCity(dest);
    this.props.actions.pbSetDestinationCity(source);
  };

  renderNoResultsFoundPage = () => {
    return (
      <div className="no-results-found">
        <KuposSuccessFailure
          title={this.props.t('HOME.WE_ARE_SORRY')}
          subtitle={this.props.t('HOME.NO_SERVICE')}
          infoText={this.props.t('HOME.TRY_OTHER_DEST')}
          t={this.props.t}
        >
          <div className="kupos-card">
            <NewSearchBox
              cities={
                !CommonService.isTrain()
                  ? this.props.home.uniqueCities
                  : this.props.home.uniqueCitiesTrain
              }
              openNewSearch={this.props.pbServiceList.openNewSearch}
              pbSourceCity={this.props.home.pbSourceCity}
              sourceCityOnChange={this.props.actions.pbSetSourceCity}
              pbDestinationCity={this.props.home.pbDestinationCity}
              destinationCityOnChange={this.props.actions.pbSetDestinationCity}
              onwardPBDate={this.props.home.onwardPBDate}
              onwardDateChange={this.props.actions.setOnwardPbDate}
              returnPBDate={this.props.home.returnPBDate}
              returnDateChange={this.props.actions.setReturnPbDate}
              swapCities={this.swapCities}
              newSearch={this.newSearch}
              t={this.props.t}
            />
          </div>
        </KuposSuccessFailure>
      </div>
    );
  };

  render() {
    const { t } = this.props;
    // console.log('State in service search-----------', this.state);
    return (
      <div className="pb-service-list-default-page">
        {/* <TopStrip classes={"header-box "+(this.pageType ? 'payments-page-header' : '')} history={this.props.history}>
            {this.pageType != 'passenger-details' ? this.renderSelectedSearchBox() : null}
          </TopStrip> */}
        {/* {this.renderNewSearchForm()} */}

        <Helmet>
          <title>{`pullmanbus.cl | ${this.originCityDecoded} - ${this.destCityDecoded}`}</title>
          <meta
            name="description"
            content={`pullmanbus.cl | ${this.originCityDecoded} - ${this.destCityDecoded}`}
          />
        </Helmet>

        {/* commented by tanveer on Amit's feedback */}
        {this.state.serviceList != 'NO_ROUTES_FOUND' ? (
          <div className="content-container">
            <KuposSteps
              menuButtons={this.state.stepsMenu}
              t={this.props.t}
              onStepClick={this.onStepClick}
            />
          </div>
        ) : null}

        {!this.state.getServiceListPending && this.state.serviceList ? (
          this.state.serviceList != 'NO_ROUTES_FOUND' ? (
            this.renderServicePageBody()
          ) : (
            this.renderNoResultsFoundPage()
          )
        ) : (
          <div className="content-container"> {this.renderServiceLoader()}</div>
        )}

        <KuposErrorSuccessModal
          showModal={this.state.showFilterModal}
          onHide={() => {
            this.setState({ showFilterModal: false, showFilterModalMessage: '' });
            if (this.state.filterSelected) {
              // this.clearFilter();
            }
          }}
          onButtonClick={() => {
            this.setState({
              showFilterModal: false,
              showFilterModalMessage: '',
            });
            seatsSelected = 0;
            if (this.state.filterSelected) {
              // this.clearFilter();
            }
          }}
          success={false}
          subTitle={t(this.state.showFilterModalMessage).replace(
            '8',
            (this.props.pbServiceList.selectedService &&
              this.props.pbServiceList.selectedService.res_details &&
              this.props.pbServiceList.selectedService.res_details.no_of_seats_to_be_booked) ||
              8,
          )}
        />

        <KuposModalWithButtons
          size="md"
          showModal={this.state.showModal}
          title={this.state.modalTitle}
          bodyText={this.state.modalBody}
          type="alert"
          showButton1={true}
          buttonText1={this.state.buttonText1}
          onButtonClick1={this.state.onButtonClick1 ? this.state.onButtonClick1 : this.closeModal}
          showButton2={this.state.showButton2}
          buttonText2={this.state.buttonText2}
          onButtonClick2={this.state.onButtonClick2 ? this.state.onButtonClick2 : this.closeModal}
          icon={this.state.modalIcon}
          buttonTextStyle={{ fontSize: 15 }}
          // showCloseIcon={this.state.showCloseIcon}
          // closeIconPress={this.closeModal}
          onHide={this.closeModal}
          backdrop={this.state.backdrop}
        />

        <KuposErrorSuccessModal
          showModal={this.state.showSuccessModal}
          success={this.state.modalSuccess}
          onButtonClick={() => {
            this.setState({
              showSuccessModal: false,
              modalBodyText: '',
              callReleaseSeat: false,
            });
            if (this.state.callReleaseSeat) {
              this.releaseSeats();
            }
          }}
          bodyText={this.state.modalBodyText}
          t={t}
        />
      </div>
    );
  }
}

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    pbServiceList: state.pbServiceList,
    home: state.home,
    common: state.common,
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions, ...homeActions }, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation('common')(DefaultPage));



// WEBPACK FOOTER //
// ./src/features/Pasajebus/PasajebusServiceList/DefaultPage.js